import { createRouter, createWebHistory } from 'vue-router'

import { temporaryTokenCleanupGuard } from '@/features/auth/guards/tenantTokenGuard.js'
import { routes } from '@/features/router/routes.js'

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(temporaryTokenCleanupGuard)
